import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import Link from 'components/Link';

const NABLA_URL = 'https://www.example.com/';

const StyledFooter = styled.footer`
  position: absolute;
  bottom: -30px;
`;

export default function Footer() {
  return (
    <StyledFooter>
      <Typography
        sx={(theme) => ({
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '14.52px',
          color: theme.palette.grey[600],
        })}
      >
        Copyright © {new Date().getFullYear()}{' '}
        <Link href={NABLA_URL}>NABLA WORKS</Link>. All Rights Reserved.
      </Typography>
    </StyledFooter>
  );
}
